import React, { Component } from 'react';
import radium from 'radium';

import topBanner from '../static/images/topBanner.png';
import homeRunTaiwanIcon from '../static/images/logo.png';
import videoMaskCover from '../static/videoMaskCover.jpg';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
  },
  topBanner: {
    width: '100%',
    margin: '50px 0',
    '@media (max-width: 414px)': {
      margin: '20px 0',
    },
  },
  videoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '50px 0',
    position: 'relative',
    '@media (max-width: 414px)': {
      width: '100%',
      margin: '20px 0',
    },
  },
  descriptionWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '50px 0',
    lineHeight: '7px',
    color: '#8F5827',
  },
  homeRunTaiwanIcon: {
    position: 'absolute',
    width: 150,
    top: 50,
    left: 50,
    '@media (max-width: 600px)': {
      width: 60,
      top: 10,
      left: 10,
    },
  },
  videoMaskCover: {
    position: 'absolute',
    zIndex: 999,
  },
};

class Block1 extends Component {
  static parseFBResources(cb) {
    return new Promise((resolve) => {
      FB.XFBML.parse();
      FB.Event.subscribe('xfbml.render', () => resolve());
      FB.Event.subscribe('xfbml.ready', (msg) => {
        if (msg.type === 'video' && msg.id === 'main-fb-video') {
          cb();
        }
      });
    });
  }

  static initFBSDK() {
    FB.init({
      appId: '1826661100918849',
      version: 'v2.7',
    });
  }

  constructor(props) {
    super(props);

    this.resizeListener = () => this.updateVideoSize();
    this.state = {
      loadedVideo: false,
      videoWidth: 854,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeListener);
    this.loadFBVideo();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);
  }

  async loadFBVideo() {
    Block1.initFBSDK();

    await Block1.parseFBResources(() => {
      this.setState({
        loadedVideo: true,
      });
    });
  }

  updateVideoSize() {
    let videoWrapperWidth = 854;

    if (window.matchMedia('(max-width: 479px)').matches) {
      videoWrapperWidth = document.body.clientWidth;
    } else if (window.matchMedia('(max-width: 599px) and (min-width: 480px)').matches) {
      videoWrapperWidth = document.body.clientWidth;
    } else if (window.matchMedia('(max-width: 767px) and (min-width: 600px)').matches) {
      videoWrapperWidth = 550;
    } else if (window.matchMedia('(max-width: 1023px) and (min-width: 768px)').matches) {
      videoWrapperWidth = 550;
    } else if (window.matchMedia('(max-width: 1179px) and (min-width: 1024px)').matches) {
      videoWrapperWidth = 854;
    }

    this.setState({
      videoWidth: videoWrapperWidth,
    });
  }

  render() {
    const {
      loadedVideo,
      videoWidth,
    } = this.state;

    const videoHeight = videoWidth * 0.5625;

    return (
      <div style={styles.wrapper}>
        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/2016homeruntaiwan/">
          <img src={homeRunTaiwanIcon} alt="homeRunTaiwanIcon" style={styles.homeRunTaiwanIcon} />
        </a>
        <img style={styles.topBanner} src={topBanner} alt="活動banner" />
        <div style={[
          styles.videoContainer,
          { width: videoWidth, height: videoHeight },
        ]}>
          <iframe 
            src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2F2016homeruntaiwan%2Fvideos%2Fvb.556055591230516%2F1064262260409844&show_text=false&appId=146960142448480" 
            width={videoWidth} 
            height={videoHeight} 
            style="border:none;overflow:hidden" 
            scrolling="no" 
            frameborder="0" 
            allowTransparency="true" 
            allow="encrypted-media" 
            allowFullScreen="true">
          </iframe>
        </div>
        <div style={styles.descriptionWrapper}>
          <p>
            一支曾得世界少棒亞軍的少棒隊
          </p>
          <p>
            一群奮力追逐棒球夢的孩子
          </p>
          <p>
            一個因為思念家人而逃隊的菜鳥隊員
          </p>
          <p>
            一位把隊員當親兄弟照顧的暖心小隊長
          </p>
          <p>
            看他們如何用汗及淚勇闖棒球夢
          </p>
          <p>
            如何在逆勢中奮力出擊
          </p>
          <p>
            在夢想路上找到「心家人」
          </p>
          <p>
            無法改編的真實人生 跨越血緣之相扶
          </p>
          <p>
            逆風高飛 暖心獻映
          </p>
        </div>
      </div>
    );
  }
}

export default radium(Block1);
